// login page validation messages
export const INCORRECT_MESSAGE = 'Username or Password is incorrect. Please try again!';
export const UNAUTHORIZED_MESSAGE = 'You are not authorized. Please try again!'
export const NETWORK_ERROR = 'Network Error.Please Try again after some time!!'
export const INACTIVEVENDOR_MESSAGE = 'Vendor is not active.'
export const CAPTCHAFAILED_MESSAGE = 'Bot verification is failed. Please try again.'
export const CAPTCHA_VERIFICATION_REQUIRED_MESSAGE = "Captcha verification is required."
export const FORBIDDEN_MESSAGE = "Insufficient permissions or scopes."
export const USER_NOT_ASSIGNED_TO_GROUP = {
    title: "Unauthorized",
    body: "User is not assigned to group. <br>Please contact support team."
}
export const MOVE_TO_SSS_ALERT = {
    title: "Action required",
    body: `<span style='font-size:12px; text-align:center'><br>This webpage is no longer available.<br>
To access SMS Payables, please log in through Sysco Supplier Suite. The link is <a href='https://supplierportal.sysco.com/login'>here</a>. Please bookmark this link in your web browser.
If you don’t have access to Sysco Supplier Suite, please request access by clicking on the Supplier button and fill out the Supplier Access Request Form from the same link <a href='https://supplierportal.sysco.com/login'> here.</a></span><br>
<img src="${require('../../src/assets/images/user_login_info.png')}" alt="User login info" style="width:150px; height:auto; display:block; margin-top:10px; margin: auto;"/>`
}

export const RESPONSE_DETAILS = [
    { key: "requestNumber", label: "Request#" },
    { key: "responder", label: "Responder" },
    { key: "requestDate", label: "Request Date" },
    { key: "ocNumber", label: "OC#" },
    { key: "poNumber", label: "PO#" },
    { key: "invoiceNumber", label: "Invoice#" },
    { key: "invoiceDate", label: "Invoice Date" },
    { key: "paymentNumber", label: "Payment#" },
    { key: "paymentDate", label: "Payment Date" },
    { key: "paymentAmount", label: "Payment Amount" },
]

export const DOC_TYPES = [
    { key: "Claims Backup", label: "Claims Backup" },
    { key: "Last Confirmed PO", label: "Last Confirmed PO(previously-Last Closed PO)" },
    { key: "Vendor Invoice", label: "Vendor Invoice(previously-Original Supplier Invoice)" },
    { key: "Check/ACH", label: "Check/ACH" },
    { key: "Backup", label: "Backup" },
    { key: "Electronic Billback", label: "Electronic Billback" },
    { key: "Expense Invoice", label: "Expense Invoice" },
];

export const LOGIN_TYPE = 'loginType'
export const COLLEAGUE_USER_TYPE = 'associate'

// login types
export const LOGIN_SSS_SUPPLIER = 'SSS_SUPPLIER';
export const LOGIN_SSS_COLLEAGUE = 'SSS_COLLEAGUE';
export const LOGIN_DIRECT = 'Direct'